export const TEXT = {
  placeholder: 'What needs to be done?',
};
